import React from "react";
const WIDTH = 90;
const DEPTH = 40;
const HEIGHT = 30;

export default {
  name: "Standard-Gas-Hob",
  prototype: "items",

  info: {
    tag: ["furnishings", "metal"],
    title: "Standard Gas Hob",
    description: "Standard-Gas-Hob",
    image: require("./Standard-Gas-Hob.svg"),
    svgIcon: require("./Standard-Gas-Hob.svg"),
  },
  properties: {
    scaleX: {
      label: "Width",
      type: "slider",
      min: 50,
      max: 250,
      defaultValue: 100,
    },
    scaleY: {
      label: "Depth",
      type: "slider",
      min: 50,
      max: 250,
      defaultValue: 100,
    },
  },

  render2D: function (element, layer, scene) {
    let angle = element.rotation + 90;

    return {
      element: (
        <g transform={`translate(-19, 55) scale(1, -1)`}>
          <defs>
            <style>{`.cls-1{fill:#fff;}`}</style>
          </defs>
          <g id={`${element.type}-${element.id}`} data-name="corner shower">
            <path
              class="cls-1"
              d="M49.92,92.91H93.23a2.16,2.16,0,0,0,2.16-2.13v-79a2.16,2.16,0,0,0-2.2-2.17H6.92a2.2,2.2,0,0,0-2.31,2.28V90.67a2.17,2.17,0,0,0,2.21,2.24Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              d="M49.92,92.91H6.82a2.17,2.17,0,0,1-2.21-2.24V11.92A2.2,2.2,0,0,1,6.92,9.64H93.19a2.16,2.16,0,0,1,2.2,2.17v79a2.16,2.16,0,0,1-2.16,2.13ZM83,12.45V90.11h9.72V12.45ZM11.82,71.3c0,7.78,6.86,13.71,13,13.62v-6.5h1.31v6.49C31.8,85.89,40,77.27,39,71.28H32.34V69.89h6.72c0-7.36-6.76-13.71-13-13.46V63H24.73V56.38c-7.17.06-13.08,7.11-12.87,13.55h6.83V71.3Zm52.3-32.41v6.6a13.32,13.32,0,0,0,9.13-4.35,14.35,14.35,0,0,0,3.83-9.38H70.25V30.38H77c-.16-7.75-6.9-13.51-12.91-13.48v6.53H62.76V16.86c-6.91.12-13,6.56-13,13.54h6.87v1.4h-6.9c.08,7.32,6.36,13.73,13.08,13.56V38.89Zm-32-7.11V30.39h4C36.08,24.54,30.81,19.68,26,19.75v3.69H24.66V19.75c-5.4-.1-10.45,5.53-10.23,10.65h4.12v1.41H14.38c0,6.15,6,11.22,10.43,10.65V38.91h1.3v3.63c5.43,0,10.31-5.79,10-10.76ZM56.61,69.91v1.42H52.48c0,6.14,5.74,11,10.34,10.69v-3.6h1.32v3.63c5.36,0,10.41-5.67,10.09-10.76h-4v-1.4h4c0-5.3-5-10.71-10.17-10.63V63H62.78V59.23c-4.88-.37-11.05,6.09-10.21,10.68Zm-5.79,1.43H45.19V90.12H62.75V83.81a12.25,12.25,0,0,1-8.29-3.9A13.26,13.26,0,0,1,50.82,71.34ZM64.15,90.13h17.4V71.35H76a13.32,13.32,0,0,1-3.57,8.49,12.36,12.36,0,0,1-8.23,4ZM43.77,31.78c-1.77,0-3.46,0-5.15,0-.59,0-.79.14-.85.75a12.83,12.83,0,0,1-9.66,11.42c-.64.16-1.29.23-2,.35v6H43.77Zm0-19.3H26v5.45c7.16,1.11,10.9,5.42,11.88,12.42h5.87Zm1.4,39.26V69.86h5.57c1-7.08,4.86-11.36,12-12.45V51.74ZM24.77,50.28c0-1.92,0-3.78,0-5.64,0-.14-.37-.39-.58-.41A12.18,12.18,0,0,1,14,36.87a36.4,36.4,0,0,1-1.52-5H7.3V50.28Zm39.39,7.14C71.26,58.58,75,62.87,76,69.87h5.5V51.76H64.16ZM7.3,12.45v18h5.37c.55-6.64,5.2-11.82,12-12.43V12.45Zm34,58.88c-1.22,9-5.9,14.55-15.07,15.84v3H43.76V71.33ZM24.8,87.08,24,87a14.65,14.65,0,0,1-9.06-4.14,16.3,16.3,0,0,1-5.16-11c0-.18-.2-.51-.32-.52-.72,0-1.45,0-2.16,0V90.11H24.8ZM45.18,31.79V50.26H62.76V47.65a1.67,1.67,0,0,0-.31-.11l-.43,0a15.16,15.16,0,0,1-11-6.22,16.32,16.32,0,0,1-3.31-8.91c0-.2-.24-.54-.38-.55C46.63,31.75,45.92,31.79,45.18,31.79ZM81.55,50.28V31.78a14.73,14.73,0,0,1-1.49,0c-.74-.09-1,.17-1.06.94a14.78,14.78,0,0,1-1.93,6.51C74.31,44,70.27,47,64.63,47.51c-.18,0-.47.24-.48.38-.05.79,0,1.6,0,2.39ZM26.14,54.13c9.19,1.31,13.93,6.78,15.12,15.73h2.51V51.76H26.14ZM7.28,69.91c.68,0,1.29,0,1.9,0,.43,0,.6-.13.62-.59A16.19,16.19,0,0,1,21.65,54.75c1-.27,2.05-.4,3.08-.6V51.78H7.28ZM81.55,12.46H64.12v2.12C73.27,16,78,21.45,79.19,30.36h2.36Zm-34,17.91c1.23-9,6-14.47,15.2-15.78V12.47H45.2v17.9Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              class="cls-1"
              d="M83,12.45h9.72V90.11H83Zm1.94,41.69a2.87,2.87,0,1,0,2.89-3A2.92,2.92,0,0,0,84.91,54.14Zm0-14.13a2.87,2.87,0,1,0,2.86-3A2.91,2.91,0,0,0,84.91,40Zm0,6.88a2.87,2.87,0,1,0,5.74,0,2.88,2.88,0,1,0-5.74,0Zm0,14.53a2.87,2.87,0,1,0,2.92-3A2.93,2.93,0,0,0,84.91,61.42Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              class="cls-1"
              d="M11.82,71.3h6.87V69.93H11.86c-.21-6.44,5.7-13.49,12.87-13.55V63h1.36V56.43c6.21-.25,13,6.1,13,13.46H32.34v1.39H39c.93,6-7.23,14.61-12.86,13.63V78.42H24.86v6.5C18.68,85,11.81,79.08,11.82,71.3Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              class="cls-1"
              d="M64.12,38.89H62.81v6.47c-6.72.17-13-6.24-13.08-13.56h6.9V30.4H49.76c0-7,6.09-13.42,13-13.54v6.57h1.36V16.9c6,0,12.75,5.73,12.91,13.48H70.25v1.38h6.83a14.35,14.35,0,0,1-3.83,9.38,13.32,13.32,0,0,1-9.13,4.35Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              class="cls-1"
              d="M32.16,31.78h4c.28,5-4.6,10.77-10,10.76V38.91h-1.3v3.55C20.34,43,14.34,38,14.38,31.81h4.17V30.4H14.43c-.22-5.12,4.83-10.75,10.23-10.65v3.69H26V19.75c4.83-.07,10.1,4.79,10.22,10.64h-4Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              class="cls-1"
              d="M56.61,69.91h-4c-.84-4.59,5.33-11,10.21-10.68V63H64.1V59.26c5.22-.08,10.21,5.33,10.17,10.63h-4v1.4h4c.32,5.09-4.73,10.78-10.09,10.76V78.42H62.82V82c-4.6.27-10.3-4.55-10.34-10.69h4.13Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              class="cls-1"
              d="M50.82,71.34a13.26,13.26,0,0,0,3.64,8.57,12.25,12.25,0,0,0,8.29,3.9v6.31H45.19V71.34Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              class="cls-1"
              d="M64.15,90.13V83.81a12.36,12.36,0,0,0,8.23-4A13.32,13.32,0,0,0,76,71.35h5.6V90.13Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              class="cls-1"
              d="M43.77,31.78v18.5H26.14v-6c.68-.12,1.33-.19,2-.35a12.83,12.83,0,0,0,9.66-11.42c.06-.61.26-.76.85-.75C40.31,31.8,42,31.78,43.77,31.78Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              class="cls-1"
              d="M43.78,12.48V30.35H37.91c-1-7-4.72-11.31-11.88-12.42V12.48Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              class="cls-1"
              d="M45.18,51.74H62.74v5.67c-7.13,1.09-11,5.37-12,12.45H45.18Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              class="cls-1"
              d="M24.77,50.28H7.3V31.84h5.17a36.4,36.4,0,0,0,1.52,5,12.18,12.18,0,0,0,10.18,7.36c.21,0,.57.27.58.41C24.79,46.5,24.77,48.36,24.77,50.28Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              class="cls-1"
              d="M64.16,57.42V51.76H81.53V69.87H76C75,62.87,71.26,58.58,64.16,57.42Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              class="cls-1"
              d="M7.3,12.45H24.63V18c-6.76.61-11.41,5.79-12,12.43H7.3Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              class="cls-1"
              d="M41.27,71.33h2.49V90.12H26.2v-3C35.37,85.88,40.05,80.34,41.27,71.33Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              class="cls-1"
              d="M24.8,87.08v3H7.3V71.3c.71,0,1.44,0,2.16,0,.12,0,.31.34.32.52a16.3,16.3,0,0,0,5.16,11A14.65,14.65,0,0,0,24,87Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              class="cls-1"
              d="M45.18,31.79c.74,0,1.45,0,2.15,0,.14,0,.36.35.38.55A16.32,16.32,0,0,0,51,41.27a15.16,15.16,0,0,0,11,6.22l.43,0a1.67,1.67,0,0,1,.31.11v2.61H45.18Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              class="cls-1"
              d="M81.55,50.28H64.12c0-.79,0-1.6,0-2.39,0-.14.3-.36.48-.38C70.27,47,74.31,44,77.07,39.22A14.78,14.78,0,0,0,79,32.71c0-.77.32-1,1.06-.94a14.73,14.73,0,0,0,1.49,0Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              class="cls-1"
              d="M26.14,54.13V51.76H43.77v18.1H41.26C40.07,60.91,35.33,55.44,26.14,54.13Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              class="cls-1"
              d="M7.28,69.91V51.78H24.73v2.37c-1,.2-2.07.33-3.08.6A16.19,16.19,0,0,0,9.8,69.33c0,.46-.19.6-.62.59C8.57,69.89,8,69.91,7.28,69.91Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              class="cls-1"
              d="M81.55,12.46v17.9H79.19C78,21.45,73.27,16,64.12,14.58V12.46Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              class="cls-1"
              d="M47.56,30.37H45.2V12.47H62.76v2.12C53.56,15.9,48.79,21.39,47.56,30.37Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              d="M84.91,54.14a2.87,2.87,0,1,1,2.88,3A2.91,2.91,0,0,1,84.91,54.14Zm2.88,2.31a2.3,2.3,0,0,0,0-4.59,2.25,2.25,0,0,0-2.23,2.26A2.22,2.22,0,0,0,87.79,56.45Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              d="M84.91,40a2.87,2.87,0,1,1,2.91,3A2.92,2.92,0,0,1,84.91,40ZM90,40a2.21,2.21,0,1,0-2.19,2.29A2.23,2.23,0,0,0,90,40Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              d="M84.91,46.89a2.87,2.87,0,1,1,2.85,3A2.94,2.94,0,0,1,84.91,46.89Zm5.07,0a2.21,2.21,0,1,0-4.41.06A2.21,2.21,0,1,0,90,46.85Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              d="M84.91,61.42a2.87,2.87,0,1,1,2.85,3A2.91,2.91,0,0,1,84.91,61.42Zm5.07.06a2.21,2.21,0,1,0-2.2,2.28A2.23,2.23,0,0,0,90,61.48Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              class="cls-1"
              d="M87.79,56.45a2.22,2.22,0,0,1-2.22-2.33,2.25,2.25,0,0,1,2.23-2.26,2.3,2.3,0,0,1,0,4.59Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              class="cls-1"
              d="M90,40a2.21,2.21,0,1,1-4.41,0A2.21,2.21,0,1,1,90,40Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              class="cls-1"
              d="M90,46.85a2.21,2.21,0,1,1-2.19-2.3A2.23,2.23,0,0,1,90,46.85Z"
              transform="translate(-4.61 -9.64)"
            />
            <path
              class="cls-1"
              d="M90,61.48a2.21,2.21,0,1,1-2.17-2.32A2.22,2.22,0,0,1,90,61.48Z"
              transform="translate(-4.61 -9.64)"
            />
          </g>
        </g>
      ),
      transform: {
        width: -WIDTH / 2,
        depth: -DEPTH / 2,
      },
    };
  },

  render3D: function (element, layer, scene) {},
};
